export class SsoOauthService {
  constructor (api) {
    this.api = api
  }

  getToken ({
    code,
    authProvider,
    redirectUrl,
    organizationId
  }) {
    const finalOrgId = organizationId || sessionStorage.getItem('currentOrgId') || null;
    return this.api.post('/v2/auth', {
      accessToken: code,
      clientType : 'custom',
      grantType: 'authorization_code',
      code,
      authProvider,
      redirectUrl,
      selectedOrganizationId: finalOrgId
    }, {
      params: { organizationId }
    })
  }
}

export default SsoOauthService
